import { Spacing } from '@doordash/design-language';

var SeparatorVerticalMargin = Spacing;
var SeparatorInset = Spacing;

export { SeparatorInset, SeparatorVerticalMargin };
